import React, { Component } from "react";
import { Table, Icon, Header, Message, Loader } from "semantic-ui-react";
import axios from "axios";
import ErrorDetail from "../Site/ErrorDetail/ErrorDetail";
import "./Site.css";

class Site extends Component {
  state = {
    crawlErrorSample: {},
    errors: null,
    detailView: false,
    isLoading: false
  };

  fetchSamples = (category, platform) => {
    this.setState({ ...this.state, isLoading: true, detailView: true,})
    let token = this.props.token;
    let website = this.props.website;
    let protocol = "https";
    let domain = website;
    if (website.slice(0, 7) === "http://") {
      domain = website.slice(7, -1);
      protocol = "http";
    } else {
      domain = website.slice(8, -1);
    }

    axios
      .get(
        `https://www.googleapis.com/webmasters/v3/sites/${protocol}%3A%2F%2F${domain}/urlCrawlErrorsSamples?category=${category}&platform=${platform}&access_token=${token}`
      )
      .then(response => {
        this.setState({
          ...this.state,
          crawlErrorSample: response.data.urlCrawlErrorSample,
          isLoading: false
        });
      })
      .catch(err => {
        console.log(err.response.data.error);
        this.setState({
          ...this.state,
          detailView: false,
          errors: err.response.data.error
        });
      });
  };

  render() {
    let errorMessage = null;
    if (this.props.errorMessage) {
      errorMessage = (
        <div className="ErrorMessages">
        <Message negative icon>
          <Icon name="attention" />
          <Message.Content>
            <Message.Header>Whoops, There seems to be an error</Message.Header>
            {this.props.errorMessage.message}
          </Message.Content>
        </Message>
        </div>
      );
    }

    let crawlErrors = null;
    let errorSample = null;
    if (this.props.crawlErrors) {
      const sortedErrors = []
        .concat(this.props.crawlErrors)
        .sort(
          (a, b) =>
            b.entries[0].count - a.entries[0].count
        );
      crawlErrors = sortedErrors.map((crawlError, index) => {
        if (crawlError.entries[0].count > 0) {
          let rowOnClick = null;
          let hasErrors = false;
          if (crawlError.entries[0].count > 0) {
            rowOnClick = () => this.fetchSamples(crawlError.category, crawlError.platform);
            hasErrors = true;
          }
          return <Table.Row key={index} onClick={rowOnClick}>
              <Table.Cell>{crawlError.category}</Table.Cell>
              <Table.Cell>{crawlError.platform}</Table.Cell>
              {crawlError.entries.map((entry, index) => {
                if (entry.count > 0) {
                  return <Table.Cell key={index} error>
                      <Icon name="attention" />
                      {entry.count}
                    </Table.Cell>;
                }
                return <Table.Cell key={index}>
                    {entry.count}
                  </Table.Cell>;
              })}
            </Table.Row>;
        }});

      if (this.state.crawlErrorSample.length > 0 && !this.state.isLoading) {
        errorSample = this.state.crawlErrorSample.map((crawlError, index) => {
          return (
            <Table.Row key={index}>
              <Table.Cell>{crawlError.responseCode}</Table.Cell>
              <Table.Cell>{crawlError.pageUrl}</Table.Cell>
            </Table.Row>
          );
        });
      } else if (this.state.isLoading) {
        errorSample = <Loader className="detailViewLoader" size="large" content="Loading" active />;
      }
    }
    return (
      <div className="SingleWebsite">
      {errorMessage}
            <Header className="WebsiteUrl" as='h2'content={this.props.website} />
        {this.state.detailView ? (
          <div className="DetailView">
            <button
              className="ui green button"
              onClick={() =>
                this.setState({ ...this.state, detailView: false })
              }
            >
              <Icon name="arrow alternate circle left" /> Return to Index
            </button>
            <Table celled basic>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={2}>Response Code</Table.HeaderCell>
                  <Table.HeaderCell width={14}>URL</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>{errorSample}</Table.Body>
            </Table>
          </div>
        ) : (
          <div className="SingleView">
            <Table selectable>
              <Table.Header>
                <Table.Row className="selectable">
                  <Table.HeaderCell>Category</Table.HeaderCell>
                  <Table.HeaderCell>Platform</Table.HeaderCell>
                  <Table.HeaderCell>Count</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>{crawlErrors}</Table.Body>
            </Table>
          </div>
        )}
      </div>
    );
  }
}

export default Site;



// WEBPACK FOOTER //
// ./src/components/CrawlErrors/Site/Site.js